import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M16 8.5a7.5 7.5 0 0 1-10.32 6.952 2.4 2.4 0 0 0-.318-.117.8.8 0 0 0-.182-.02c-.069 0-.144.012-.294.037l-2.965.495c-.31.051-.466.077-.578.029a.42.42 0 0 1-.219-.219c-.048-.112-.022-.267.03-.578l.494-2.965a2 2 0 0 0 .037-.294.8.8 0 0 0-.02-.182c-.015-.068-.049-.15-.117-.318A7.5 7.5 0 1 1 16 8.5"
    }, null, -1)
  ])))
}
export default { render: render }